const localURL = "https://api-dev.aiplusi.com/";
// const localURL = "https://api-staging.aiplusi.com/";
// const localURL = "https://api-www.chataible.com/";
// const localURL = "https://api-gcp.d.aiplusi.com/";
// const localURL = "https://api-next.d.aiplusi.com/";
// const localURL = "https://api-bigquery.d.aiplusi.com/";
// const localURL = "https://api-gcp-beta.p.iamaible.com/";
// const localURL = "https://api.iamaible.com";
// const localURL = "https://api-halloween.d.aiplusi.com/";
const localBaseRequestURL = (() => {
    // from DefinePluginL DEFAULT_API_ENDPOINT
    let endpoint = DEFAULT_API_ENDPOINT || localURL;
    if (!endpoint.startsWith("https://") && !endpoint.startsWith("http://")) {
        endpoint = `https://${endpoint}`;
    }
    if (!endpoint.endsWith("/")) {
        endpoint = `${endpoint}/`;
    }
    return endpoint;
})();
export const baseRequestURL = 
// @ts-expect-error: window type hasn't been extended to include looker metadata
window?.lookerExtensionMetadata?.entitlements?.external_api_urls?.[5] !== undefined
    ? // @ts-expect-error: window type hasn't been extended to include looker metadata
        window?.lookerExtensionMetadata?.entitlements?.external_api_urls?.[5]
    : window && window.location && window.location.href && window.location.href.startsWith("http://localhost")
        ? localBaseRequestURL
        : "/_api/";
// "https://api-demo.aiplusi.com/";
// "https://api.aiplusi.com/";
export function constructQueryParams(queryArr = []) {
    let queryParams = queryArr.filter((elem) => elem).join("&");
    if (queryParams) {
        queryParams = "?" + queryParams;
    }
    return queryParams;
}
const testEnvironments = {
    "GCP-May-15th": 2596,
    "AWS-May-15th": 2599
};
const testLocalArmen = undefined;
const armenUrl = "http://127.0.0.1:5001";
export function redirectIfArmenTesting(url, account) {
    if (testLocalArmen && testEnvironments[testLocalArmen] == account?.id) {
        console.log("Redirecting account %i (%s) to %s", account?.id, testLocalArmen, armenUrl);
        return armenUrl;
    }
    else {
        return undefined;
    }
}
